import React, { Component, useState } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import {
  APIHandler,
  BackButton,
  PremiumHotel,
  FreeHotel,
  StorageHandler,
} from "C4";
import { baseAppId, storageKeys } from "settings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Multiselect } from "multiselect-react-dropdown";
import i18n from "i18n-react";

import SimpleBarReact from "simplebar-react";
import "simplebar/src/simplebar.css";

import MarkerFree from "assets/images/ab-mapGrey.png";
import ClusterFree from "assets/images/ab-mapClusterGrey.png";
import MarkerPremium from "assets/images/ab-map.png";
import ClusterPremium from "assets/images/ab-mapCluster.png";

let containerStyle = {
  width: "100%",
  height: "calc(100vh - 8rem)",
};
const params = new URLSearchParams(window.location.search);
if (params.get("mobile")) {
  containerStyle = {
    width: "100%",
    height: "100vh",
  };
}

const clusterPremium = {
  styles: [
    {
      url: ClusterPremium,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

const clusterFree = {
  styles: [
    {
      url: ClusterFree,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

export default class DirectoryView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      premiumHotelsList: [],
      freeHotelsList: [],
      lat1: 17.435967369977597,
      lat2: 17.19473346847961,
      lon1: -62.577953078125,
      lon2: -62.907542921875,
      loading: false,
      query: "",
      category: "",
      subcategory: "",
      michelin: "",
      rating: "",
      cuisine: "",
      width: null,
      mobile: false,
      zoom: 12,
      center: {
        lat: 17.31539,
        lng: -62.742748,
      },
      color: "16638b",
      font: "Source Sans Pro",
      userInfo: "",
      categories: [
        { name: "All", id: "category" },
        { name: "Accommodations", id: "category" },
      ],
      subcategories: {
        sportshobbiesactivities: [
          "Sports, Hobbies & Activities: Scuba Diving",
          "Sports, Hobbies & Activities: Snorkeling",
          "Sports, Hobbies & Activities: SUP / Paddleboarding",
          "Sports, Hobbies & Activities: Fishing",
          "Sports, Hobbies & Activities: Camping",
          "Sports, Hobbies & Activities: Trekking & Hiking",
          "Sports, Hobbies & Activities: Kayaking",
          "Sports, Hobbies & Activities: River Rafting",
          "Sports, Hobbies & Activities: River Tubing",
          "Sports, Hobbies & Activities: Ziplining",
          "Sports, Hobbies & Activities: Miniature Golf",
          "Sports, Hobbies & Activities: Jet Skiing",
          "Sports, Hobbies & Activities: Other Watersports",
          "Sports, Hobbies & Activities: Rappelling",
          "Sports, Hobbies & Activities: Bowling",
          "Sports, Hobbies & Activities: Recreational Walking",
          "Sports, Hobbies & Activities: Surfing Lessons",
          "Sports, Hobbies & Activities: Golf",
          "Sports, Hobbies & Activities: Biking",
          "Sports, Hobbies & Activities: Biking Trails",
          "Sports, Hobbies & Activities: Paintball",
          "Sports, Hobbies & Activities: 4-Wheeler / ATVs",
          "Sports, Hobbies & Activities: Surfing Equipment",
          "Sports, Hobbies & Activities: Horseback Riding",
          "Sports, Hobbies & Activities: Sailing",
          "Sports, Hobbies & Activities: Birding",
          "Sports, Hobbies & Activities: Surf Spots",
          "Sports, Hobbies & Activities: Rock Climbing",
          "Sports, Hobbies & Activities: Go-Karts",
          "Sports, Hobbies & Activities: Boat Rentals & Charters",
          "Sports, Hobbies & Activities: Cave Tubing",
          "Sports, Hobbies & Activities: Windsurfing",
          "Sports, Hobbies & Activities: Kitesurfing / Kiteboarding",
          "Sports, Hobbies & Activities: Hang Gliding",
          "Sports, Hobbies & Activities: Scenic Flights",
          "Sports, Hobbies & Activities: Parasailing",
          "Sports, Hobbies & Activities: Skydiving",
          "Sports, Hobbies & Activities: Balloon Rides",
        ],
        landmarkspointsofinterest: [
          "Landmarks & Points of Interest: Architectural Sites",
          "Landmarks & Points of Interest: U.S. National Register of Historic Places Listings",
          "Landmarks & Points of Interest: Beaches",
          "Landmarks & Points of Interest: Playgrounds",
          "Landmarks & Points of Interest: Town Halls",
          "Landmarks & Points of Interest: Houses of Important Figures",
          "Landmarks & Points of Interest: Photo Spots / Viewpoints",
          "Landmarks & Points of Interest: City / Town Plazas",
          "Landmarks & Points of Interest: Ruins & Abandoned Places",
          "Landmarks & Points of Interest: Fortresses",
          "Landmarks & Points of Interest: Historic Walking Areas",
          "Landmarks & Points of Interest: Public Parks",
          "Landmarks & Points of Interest: Rivers",
          "Landmarks & Points of Interest: Lakes",
          "Landmarks & Points of Interest: Archaeological Sites",
          "Landmarks & Points of Interest: Lighthouses",
          "Landmarks & Points of Interest: Bays",
          "Landmarks & Points of Interest: Churches & Religious Centers",
          "Landmarks & Points of Interest: Libraries",
          "Landmarks & Points of Interest: Statues",
          "Landmarks & Points of Interest: Forests",
          "Landmarks & Points of Interest: Mountains",
          "Landmarks & Points of Interest: Swimming Holes",
          "Landmarks & Points of Interest: Boardwalks",
          "Landmarks & Points of Interest: Natural Springs",
          "Landmarks & Points of Interest: Caves",
          "Landmarks & Points of Interest: Indigenous Sites",
          "Landmarks & Points of Interest: Monuments",
          "Landmarks & Points of Interest: Bioluminescent Bays",
          "Landmarks & Points of Interest: Coffee Plantations",
          "Landmarks & Points of Interest: Murals",
          "Landmarks & Points of Interest: Canyons",
          "Landmarks & Points of Interest: Inscribed Rocks",
          "Landmarks & Points of Interest: Waterfalls",
          "Landmarks & Points of Interest: Theaters",
          "Landmarks & Points of Interest: Universities & Schools",
          "Landmarks & Points of Interest: Visitor Centers",
          "Landmarks & Points of Interest: Castles",
          "Landmarks & Points of Interest: Legends & Ghosts",
          "Landmarks & Points of Interest: Historic Estates",
          "Landmarks & Points of Interest: UNESCO Heritage Sites",
          "Landmarks & Points of Interest: Bridges",
          "Landmarks & Points of Interest: Islands",
          "Landmarks & Points of Interest: Cays",
          "Landmarks & Points of Interest: Marinas / Yacht Clubs",
          "Landmarks & Points of Interest: Cemeteries & Mausoleums",
          "Landmarks & Points of Interest: Lagoons",
          "Landmarks & Points of Interest: Reefs",
          "Landmarks & Points of Interest: Towers",
          "Landmarks & Points of Interest: Gardens",
          "Landmarks & Points of Interest: Farms",
          "Landmarks & Points of Interest: Fountains",
          "Landmarks & Points of Interest: Ranches",
          "Landmarks & Points of Interest: Sculptures",
          "Landmarks & Points of Interest: Dams",
          "Landmarks & Points of Interest: Caverns",
        ],
        membership: [
          "Membership Directory: Volunteer Opportunities: Arts & Culture",
          "Membership Directory: Volunteer Opportunities: Environment",
        ],
        accommodations: [
          "Hotel",
          "Villas, Condominums, Apartments",
          // "Accommodations: Bed & Breakfasts",
          // "Accommodations: Condos & Apartment Rentals",
          // "Accommodations: Small Inns & Guest Houses",
          // "Accommodations: House & Villa Rentals",
          // "Accommodations: Hotels",
          // "Accommodations: Resorts",
          // "Accommodations: Homestays",
          // "Accommodations: Campgrounds - Tent Sites",
          // "Accommodations: Campgrounds - Trailer Sites",
          // "Accommodations: Hostels / Backpackers",
          // "Accommodations: Unique Rentals",
          // "Accommodations: Glamping",
          // "Accommodations: Paradores",
          // "Accommodations: Motels",
        ],
        attractions: [
          "Attractions: Art Galleries",
          "Attractions: Amusement Parks",
          "Attractions: Water Parks",
          "Attractions: Movie Theaters / Cinemas",
          "Attractions: Wildlife Refuges & Nature Reserves",
          "Attractions: Thermal Pools",
          "Attractions: National Parks",
          "Attractions: Nature Centers",
          "Attractions: Agritourism",
          "Attractions: Distilleries",
          "Attractions: Casinos",
          "Attractions: Event Ticketing",
          "Attractions: Escape Rooms",
          "Attractions: Horse Racing",
          "Attractions: Botanical Gardens",
          "Attractions: Dance Shows",
        ],
        dining: [
          "Dining: Food Stands",
          "Dining: Chinchorros",
          "Dining: Restaurants",
          "Dining: Pubs & Sports Bars",
          "Dining: Cafeterias",
          "Dining: Bistros, Lounges & Gastropubs",
          "Dining: Bakeries / Pastry Shops",
          "Dining: Coffee Shops",
          "Dining: Food Trucks",
          "Dining: Specialty Food Shops",
          "Dining: Delis",
          "Dining: Breweries",
          "Dining: Fast Food",
          "Dining: Diners",
        ],
        eventservices: [
          "Event Services: Travel Agencies",
          "Event Services: Event Coordinators & Meeting Planners",
          "Event Services: Event Management Companies",
          "Event Services: Catering",
          "Event Services: Air Freight, Packages & Shipping",
          "Event Services: Group-Friendly Activities & Tours",
          "Event Services: Tour & Ground Operators / Charters",
          "Event Services: Training & Teambuilding Companies",
          "Event Services: Wedding Photography",
          "Event Services: Event Photography",
          "Event Services: Wedding Planners & Coordinators",
          "Event Services: Musicians & Entertainers",
          "Event Services: Health Spas / Wellness Programs",
          "Event Services: Flowers & Decoration",
          "Event Services: Linen, Chair & Table Rentals",
          "Event Services: Signs & Displays / Graphics / Printing",
          "Event Services: Workshop & Seminar Speakers",
          "Event Services: Audiovisual",
          "Event Services: Light & Sound Effects",
          "Event Services: Service Professionals",
          "Event Services: Hair & Makeup",
          "Event Services: Foreign Language Specialists",
          "Event Services: Promo Items, Awards & Gifts",
          "Event Services: Temp Staffing & Employment Services",
          "Event Services: Group-Friendly Attractions",
          "Event Services: Destination Management Companies",
          "Event Services: Music & Entertainment Promoters",
          "Event Services: Webcasting & Internet Services",
          "Event Services: Fine Pastries",
          "Event Services: Exposition & Tradeshow Contractors",
          "Event Services: Travel Wholesalers",
          "Event Services: Security System Companies",
          "Event Services: Office Supplies",
          "Event Services: Computer Rental, Data Processing & IT",
        ],
        eventvenues: [
          "Event Venues: Accommodation On Site",
          "Event Venues: Meeting Rooms",
          "Event Venues: Conference Centers",
          "Event Venues: Group Dining Venues",
          "Event Venues: No Accommodation on Site",
          "Event Venues: Ceremony Venues",
          "Event Venues: Reception Venues",
          "Event Venues: Convention Centers",
          "Event Venues: Ballrooms",
          "Event Venues: Banquet Venues",
          "Event Venues: Theater / Show Venues",
          "Event Venues: Concert Venues",
          "Event Venues: Stadiums",
        ],
        medicaltourism: [
          "Medical Tourism: Dental",
          "Medical Tourism: Hospitals",
        ],
        museum: [
          "Museums: History Museums",
          "Museums: Art Museums",
          "Museums: Science Museums",
          "Museums: Archaeology Museums",
          "Museums: Agriculture Museums",
          "Museums: Music Museums",
          "Museums: Folklore & Indigenous Museums",
        ],
        nightlife: [
          "Nightlife: Dance Clubs",
          "Nightlife: Karaoke",
          "Nightlife: Sports Bars",
          "Nightlife: Comedy Clubs",
          "Nightlife: Live Music",
          "Nightlife: Lounges",
          "Nightlife: Cocktail Bars",
          "Nightlife: Cigar Bars",
          "Nightlife: Speakeasies",
          "Nightlife: Gay Bars",
          "Nightlife: Wine Bars",
        ],
        shopping: [
          "Shopping: Clothing Stores",
          "Shopping: Specialty Shops",
          "Shopping: Sports / Outdoors Outfitters",
          "Shopping: Gift Shops",
          "Shopping: Shopping Centers / Plazas",
          "Shopping: Arts & Crafts",
          "Shopping: Made in Puerto Rico",
          "Shopping: Grocery Stores",
          "Shopping: Malls",
          "Shopping: Jewelry Stores",
          "Shopping: Department Stores",
          "Shopping: Flea Markets",
          "Shopping: Open-Air Markets",
          "Shopping: Boutiques",
          "Shopping: Farmers' Markets",
          "Shopping: Outlets",
        ],
        sportsmarketing: [
          "Sports Marketing: Associations & Federations",
          "Sports Marketing: Baseball Venues",
          "Sports Marketing: Basketball Venues",
          "Sports Marketing: Swimming Venues",
          "Sports Marketing: Tennis Venues",
          "Sports Marketing: Track & Field Venues",
          "Sports Marketing: Volleyball Venues",
          "Sports Marketing: Soccer / Football Venues",
          "Sports Marketing: Golf Venues",
          "Sports Marketing: Softball Venues",
          "Sports Marketing: Fishing Tournament Venues",
          "Sports Marketing: Martial Arts Venues",
          "Sports Marketing: Skateboarding Venues",
          "Sports Marketing: Sports Promoters",
        ],
        tours: [
          "Tours: Adventure Tours",
          "Tours: Guided Tours",
          "Tours: Boat Tours",
          "Tours: Cave Tours",
          "Tours: Nature & Eco Tours",
          "Tours: Sightseeing Tours",
          "Tours: Student & Youth Tours",
          "Tours: Cultural Tours",
          "Tours: Bike Tours",
          "Tours: Historical Tours",
          "Tours: Food Tours",
          "Tours: Walking Tours",
          "Tours: Agricultural Tours",
          "Tours: Shopping Tours",
          "Tours: Night Tours",
          "Tours: Driving Tours",
          "Tours: Distillery Tours",
          "Tours: Bus & Trolley Tours",
          "Tours: Motorcycle Tours",
        ],
        transportation: [
          "Transportation: Airports",
          "Transportation: Airlines",
          "Transportation: Buses",
          "Transportation: Luxury Transportation",
          "Transportation: Private Transportation",
          "Transportation: Car / Van Rentals",
          "Transportation: Aircraft Charters - Helicopter",
          "Transportation: Taxis",
        ],
        wellness: [
          "Wellness: Gyms & Fitness Centers",
          "Wellness: Yoga",
          "Wellness: Spas",
          "Wellness: Meditation",
        ],
      },
      filterOpen: false,
      logo: null,
    };

    this.onSelect = this.onSelect.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    let mobile = false;
    if (params.get("mobile") || params.get("header") === "false") {
      mobile = true;
    }
    this.setState({ mobile: mobile, width: width });

    if (width < 800) {
      this.getHotelsList();
    }
    this.getLogo();
  }

  async getLogo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logoWhite,
      });
    }
  }

  handleInputChange = () => {
    this.setState(
      {
        query: this.search.value,
      },
      this.getHotelsList()
    );
  };

  loadProperties(bounds, zoom) {
    this.setState({
      lat1: bounds.getNorthEast().lat(),
      lat2: bounds.getSouthWest().lat(),
      lon1: bounds.getNorthEast().lng(),
      lon2: bounds.getSouthWest().lng(),
      zoom: zoom,
    });
    this.getHotelsList();
  }

  getHotelsList() {
    this.setState({ loading: true, freeHotelsList: [] });
    setTimeout(() => {
      const {
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category,
        cuisine,
        michelin,
        rating,
        subcategory,
      } = this.state;
      APIHandler.getFreeHotelsList(
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category,
        cuisine,
        michelin,
        rating,
        subcategory
      ).then((results) => {
        this.setState({ freeHotelsList: results, loading: false });
      });
    }, 200);

    // APIHandler.getPremiumHotelsList(lat1, lat2, lon1, lon2).then((results) => {
    //   this.setState({ premiumHotelsList: results.items });
    // });
  }

  flyToMarker = (lat, lon) => {
    this.setState({
      zoom: 20,
      center: {
        lat: Number(lat),
        lng: Number(lon),
      },
    });
  };

  resetMap = () => {
    this.setState({
      zoom: 12,
      center: {
        lat: 17.31539,
        lng: -62.742748,
      },
    });
  };

  resetFilters = () => {
    window.location.reload(false);
  };

  premiumInfo = (userInfoID) => {
    document.getElementById("iframe").classList.remove("hide");
    this.setState({
      userInfo: `https://travproconnect.com/profile/${userInfoID}?app_id=${baseAppId}`,
    });
  };

  freeInfo = (userInfoID) => {
    console.log(userInfoID);
    if (this.state.mobile) {
      window.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=130&mobile=true&header=false`,
        "*"
      );
      window.ReactNativeWebView.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=13&mobile=true&header=false`,
        "*"
      );
    } else {
      document.getElementById("iframe").classList.remove("hide");
      this.setState({
        userInfo: `https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=13`,
      });
    }
  };

  onSelect = (selectedList, selectedItem) => {
    console.log();
    if (selectedItem.id === "category") {
      this.setState(
        {
          category: selectedItem["name"],
          subcategory: "",
        },
        () => {
          this.getHotelsList();
        }
      );
    } else {
      this.setState(
        {
          subcategory: selectedItem["name"],
        },
        () => {
          this.getHotelsList();
        }
      );
    }
  };

  onRemove(selectedList, removedItem) {
    const array = [...this.state[removedItem.id]];
    const index = array.indexOf(removedItem["name"]);
    if (removedItem.id === "category") {
      this.setState(
        {
          category: "",
          subcategory: "",
        },
        () => {
          this.getHotelsList();
        }
      );
    } else {
      if (removedItem.id === "subcategory") {
        this.setState(
          {
            subcategory: "",
          },
          () => {
            this.getHotelsList();
          }
        );
      }
    }
  }

  transformOptions = (options) => {
    return options.map((option) => ({ name: option }));
  };

  handleCheck = (e) => {
    if (this.state[e.target.id] === "") {
      this.setState(
        {
          [e.target.id]: 1,
        },
        () => {
          this.getHotelsList();
        }
      );
    } else {
      this.setState(
        {
          [e.target.id]: "",
        },
        () => {
          this.getHotelsList();
        }
      );
    }
  };

  closeIframe() {
    document.getElementById("iframe").classList.add("hide");
  }

  toggleFilter = () => {
    this.setState({
      filterOpen: !this.state.filterOpen,
    });
  };

  render() {
    const {
      premiumHotelsList,
      freeHotelsList,
      zoom,
      center,
      userInfo,
      mobile,
      width,
      loading,
      filterOpen,
      logo,
      category,
      subcategories,
      subCategory,
    } = this.state;

    const normalizedCategory = category
      .replace(/ /g, "")
      .replace(/&/g, "")
      .replace(/:/g, "")
      .replace(/,/g, "")
      .toLowerCase();

    const options = this.transformOptions(
      subcategories[normalizedCategory] || []
    );

    const selectSubcategory = this.transformOptions(
      subCategory ? [subCategory] : []
    );

    return (
      <div className="directoryContainer">
        {!mobile && (
          <div className="header">
            <BackButton
              useHistory={false}
              text={i18n.translate("general.back")}
            />
            <div className="search">
              <FontAwesomeIcon
                icon={["fas", "search"]}
                className="searchIcon"
              />
              <input
                className="searchInput"
                placeholder={i18n.translate("directoryView.search")}
                type="text"
                ref={(input) => (this.search = input)}
                onChange={this.handleInputChange}
              />
            </div>
            <img src={logo} className="logo" alt="logo" />
          </div>
        )}
        {mobile && (
          <style>
            {
              "\
              .cookieConsent { display: none !important; } .directoryContainer { height: 100vh; } .results { top: 0 !important; } .listContainer { height: calc(100vh - 22rem) !important; margin-top: 0 !important; } @media screen and (min-width: 699px) { .listContainer { height: calc(100vh - 18rem) !important; } }"
            }
          </style>
        )}
        <div className="directoryView">
          <div className="leftSide">
            <div className="results">
              {i18n.translate("directoryView.amountOfResults")}
              {freeHotelsList.length + premiumHotelsList.length}
              <button
                onClick={filterOpen ? this.toggleFilter : this.toggleFilter}
                className="filter-btn"
              >
                {filterOpen
                  ? i18n.translate("general.close")
                  : i18n.translate("directoryView.filter")}
              </button>
            </div>
            <div className="leftGrid">
              <div className={`filterContainer ${filterOpen ? "active" : ""}`}>
                <div className="type">
                  <Multiselect
                    options={this.state.categories}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue="name"
                    placeholder="Filter by Category"
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                    singleSelect={true}
                  />
                </div>

                {selectSubcategory}
                {category &&
                  this.state.subcategories[
                    category
                      .replace(/ /g, "")
                      .replace(/&/g, "")
                      .replace(/:/g, "")
                      .replace(/,/g, "")
                      .toLowerCase()
                  ] && (
                    <div className="price" key={category}>
                      <Multiselect
                        options={options}
                        selectedValues={selectSubcategory}
                        onSelect={this.onSelect}
                        onRemove={this.onRemove}
                        displayValue="name"
                        placeholder="Sub Filter"
                        showArrow={true}
                        avoidHighlightFirstOption={true}
                        singleSelect={true}
                        key={subCategory}
                      />
                    </div>
                  )}

                <div
                  className="resetFilters"
                  onClick={() => {
                    this.resetFilters();
                  }}
                >
                  {i18n.translate("directoryView.resetFilters")} >
                </div>
                <div className="text-center">
                  <button
                    onClick={this.resetFilters}
                    className="filter-btn inverted"
                  >
                    {i18n.translate("directoryView.resetFilters")}
                  </button>
                  <button onClick={this.toggleFilter} className="show-results">
                    {i18n.translate("directoryView.showResults")}
                  </button>
                </div>
              </div>

              {mobile && (
                <div className="search">
                  <FontAwesomeIcon
                    icon={["fas", "search"]}
                    className="searchIcon"
                  />
                  <input
                    className="searchInput"
                    placeholder={i18n.translate("directoryView.search")}
                    type="text"
                    ref={(input) => (this.search = input)}
                    onChange={this.handleInputChange}
                  />
                </div>
              )}

              <SimpleBarReact
                className={`listContainer ${filterOpen ? "filterOpen" : ""}`}
              >
                <div className="premiumList">
                  {loading && (
                    <span className="loader">
                      <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
                    </span>
                  )}
                  {premiumHotelsList.length > 0 &&
                    premiumHotelsList.map((hotel) => (
                      <PremiumHotel
                        key={hotel.id}
                        id={hotel.id}
                        bgImage={hotel.headerImages[0]}
                        propertyName={hotel.propertyName}
                        flyToMarker={() => {
                          this.flyToMarker(
                            hotel.coords.latitude,
                            hotel.coords.longitude
                          );
                        }}
                        hotelInfo={() => {
                          this.premiumInfo(hotel.userInfoID);
                        }}
                      />
                    ))}
                </div>
                <div className="freeList">
                  {freeHotelsList.length === 0 && !loading && (
                    <div className="noResults">
                      {i18n.translate("directoryView.noResults")}
                    </div>
                  )}
                  {/* Filter duplicates, because items are created for each category and can't have multiple */}
                  {freeHotelsList.length > 0 &&
                    freeHotelsList.map((hotel, i) => (
                      <React.Fragment key={hotel.company_listing_id}>
                        <FreeHotel
                          id={hotel.company_listing_id}
                          bgImage={hotel.img_path + hotel.photo_file}
                          flyToMarker={() => {
                            this.flyToMarker(hotel.latitude, hotel.longitude);
                          }}
                          hotelInfo={() => {
                            this.freeInfo(hotel.listing_id);
                          }}
                          hotelName={hotel.company}
                          location={hotel.state}
                          item={hotel}
                        />
                      </React.Fragment>
                    ))}
                  {zoom > 8 && (
                    <div
                      className="resetMap"
                      onClick={() => {
                        this.resetMap();
                      }}
                    >
                      {i18n.translate("directoryView.resetMap")}
                    </div>
                  )}
                </div>
              </SimpleBarReact>
            </div>
          </div>
          {width > 700 && (
            <div className="rightSide">
              <LoadScript googleMapsApiKey="AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc">
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={zoom}
                  onLoad={(map) => {
                    this.map = map;
                  }}
                  onIdle={() => {
                    this.loadProperties(
                      this.map.getBounds(),
                      this.map.getZoom()
                    );
                  }}
                >
                  {/* Child components, such as markers, info windows, etc. */}
                  <MarkerClusterer
                    minimumClusterSize={4}
                    gridSize={100}
                    options={clusterFree}
                  >
                    {(clusterer) => {
                      return (
                        freeHotelsList.length > 0 &&
                        freeHotelsList.map((freeHotel) => (
                          <Marker
                            key={freeHotel.listing_id}
                            position={{
                              lat: Number(freeHotel.latitude),
                              lng: Number(freeHotel.longitude),
                            }}
                            icon={MarkerFree}
                            onClick={() => {
                              this.flyToMarker(
                                freeHotel.latitude,
                                freeHotel.longitude
                              );
                            }}
                            clusterer={clusterer}
                          />
                        ))
                      );
                    }}
                  </MarkerClusterer>
                  <MarkerClusterer
                    minimumClusterSize={5}
                    options={clusterPremium}
                  >
                    {(clusterer) => {
                      return (
                        premiumHotelsList.length > 0 &&
                        premiumHotelsList.map((premiumHotel) => (
                          <Marker
                            key={premiumHotel.id}
                            position={{
                              lat: premiumHotel.coords.latitude,
                              lng: premiumHotel.coords.longitude,
                            }}
                            icon={MarkerPremium}
                            onClick={() => {
                              this.flyToMarker(
                                premiumHotel.coords.latitude,
                                premiumHotel.coords.longitude
                              );
                            }}
                            clusterer={clusterer}
                          ></Marker>
                        ))
                      );
                    }}
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>
            </div>
          )}

          <div className="iframe hide" id="iframe">
            <div
              className="bgIframe"
              onClick={() => {
                this.closeIframe();
              }}
            ></div>
            <div className="iframeHolder">
              <div
                className="closeIframe"
                href="#"
                onClick={() => {
                  this.closeIframe();
                }}
              >
                <span className="closeText">
                  <FontAwesomeIcon icon={["fas", "chevron-left"]} />{" "}
                  {i18n.translate("general.back")}
                </span>
              </div>
              <div className="contentIframe">
                <iframe
                  width="100%"
                  height="100%"
                  id="iframeModal"
                  src={userInfo}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
